export const SVG_SIZE = 8;
export const BUTTON_VARIANT = 'outline';
export const BUTTON_HEIGHT = 10;
